import React from 'react';
import { IconButton } from '@mui/material';
import { formatDirectionsUrlWithAddress } from '../../utils';
import logger from '../../logger';
import DirectionsIcon from '@mui/icons-material/Directions';
import { LocalAtRecord } from '../../db';
import { DropoffsFieldSet } from '@rogoag/airtable/crm';

type DirectionsButtonProps = {
  dropoffRecord: LocalAtRecord<DropoffsFieldSet> | undefined;
  dropoffName: string;
};

const DirectionsButton = ({ dropoffName, dropoffRecord }: DirectionsButtonProps) => {
  return (
    <a
      target="_blank"
      rel="noreferrer"
      href={formatDirectionsUrlWithAddress(dropoffRecord?.get('Location'))}
      onClick={async (e) => {
        e.stopPropagation();
        await logger.log('CLICK_DIRECTIONS', `Selected Directions: ${dropoffName}`);
      }}
    >
      <IconButton disabled={!dropoffRecord} color="secondary" size="large">
        <DirectionsIcon fontSize="large" />
      </IconButton>
    </a>
  );
};

export default DirectionsButton;
